<template>
    <transition name="bounce">
        <button @click="$emit('clicked')" v-if="show">
            <img :src="plus" class="icon" alt="plus">
            {{ text }}
        </button>
    </transition>
</template>

<script>
import plus from '@/assets/svg/plus-thick.svg'

export default {
    name: 'NewButton',
    props: {
        text: {
            type: String,
            default: 'New'
        }
    },
    data() {
        return {
            plus,
            show: false
        }
    },
    mounted() {
        setTimeout(() => {
            this.show = true
        }, 300)
    },
    unmounted() {
        this.show = false
    }
}
</script>

<style scoped>
.icon {
    width: 15px;
    filter: invert();
}

button {
    background-color: var(--dark-blue);
    display: flex;
    align-items: center;
    gap: 5px;
    font-family: var(--font);
    color: white;
    border: none;
    //border-radius: var(--br);
    border-radius: 21px;
    padding: 10px 18px;
    font-size: 16px;
    font-weight: 400;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    //margin: 15px 0;
    margin: 0;
}

button:hover {
    background-color: var(--lighter-blue);
}

button:active {
    scale: 0.98;
}
</style>
